module.exports = __webpack_public_path__ + "img/uk.9da723d4.png";